import { Component } from "@angular/core";
import { Platform } from "ionic-angular";
import { TranslateService } from "@ngx-translate/core";

@Component({
  templateUrl: "app.html",
})
export class MyApp {
  // @ViewChild(Nav) nav: Nav;

  // make HelloIonicPage the root (or first) page
  rootPage = "dashboard";
  constructor(
    public platform: Platform,
    // public menu: MenuController,
    // public statusBar: StatusBar,
    // public splashScreen: SplashScreen,
    // public app: App,
    public translate: TranslateService
  ) {
    this.initializeApp();
    // set our app's pages
  }

  initializeApp() {
    let authenticatedUser: any = { id: null, token: null, route: null };
    if (document.URL.indexOf("?") > 0) {
      let splitURL = document.URL.split("?");
      let splitParams = splitURL[1].split("&");
      let i: any;
      for (i in splitParams) {
        let singleURLParam = splitParams[i].split("=");
        if (singleURLParam[0] == "uid") {
          authenticatedUser.id = singleURLParam[1];
        }
        if (singleURLParam[0] == "auth") {
          authenticatedUser.token = singleURLParam[1];
        }
        if (singleURLParam[0] == "route") {
          authenticatedUser.route = singleURLParam[1];
        }
      }
    }

    this.platform.ready().then(() => {
      if (authenticatedUser.token) {
        (window as any).authenticatedUser = authenticatedUser;
      }
      const lang = navigator.language.split("-")[0];
      this.translate.setDefaultLang("it");
      this.translate.use(lang);
      //this.statusBar.styleDefault();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts